import React, { useMemo } from 'react';
import FormDrawer from "components/__new/common/form-drawer";
import { ButtonLoader } from "components/__new/common/form";
import CustomSwitch from '../common/form/CustomSwitch';
import { generateUniqueId } from 'utils/generateUniqueId';
import { ReactComponent as AddIcon } from "assets/images/icons/add-01.svg";
import { ReactComponent as ArrowBack } from "assets/images/icons/arrow_back.svg";
import Maybe from '../common/Maybe';
import { CustomDeductions } from './CustomDeductions';

export const PayStructureFormStep2 = (props) => {
  const { formAction, form, setForm, handleTogglePayStructureModal, setIsOpen, step, setStep, loading, editLoading } = props;
  
  const handleDeductionsChange = (name) => {
    setForm(prevState => {
      const newDeductions = {
        ...prevState.deductions,
        [name]: !prevState.deductions[name]
      }
      
      return {
        ...prevState,
        deductions: { ...newDeductions }
      }
    })
  }
  
  const handleAddNewCustomDeduction = () => {
    setForm(prevState => {
      const newDeductions = {
        ...prevState.deductions,
        custom_deductions: [
          ...prevState.deductions.custom_deductions,
          {
            name: "",
            description: "",
            source: "",
            type: "",
            value: "",
            is_shown_on_payslip: false,
            is_remitted_to_government: false,
            id: generateUniqueId(),
          }
        ]
      }
      return {
        ...prevState,
        deductions: {...newDeductions},
      }
    })
  }
  
  const isSubmitBtnDisabled = useMemo(() => {
    if (form.deductions.custom_deductions.length === 0) return false;
    
    for (const customDeduction of form.deductions.custom_deductions) {
      if (!customDeduction.name || !customDeduction.source || !customDeduction.type || !customDeduction.value) {
        return true;
      }
    }
    return false;
  }, [form.deductions.custom_deductions])
  
  return (
    <div className='p-6'>
      <div className='relative pb-1 mb-8 border-b border-gray-100'>
        <div className='absolute left-0 top-0 bg-[#ECECEC] w-fit cursor-pointer rounded-lg flex justify-center items-center' style={{ width: "35px", height: "35px" }} onClick={() => setStep(1)}>
          <ArrowBack width={25} height={25} />
        </div>
        <div className='ml-12'>
          <FormDrawer.Title
            title="Statutory Deductions"
            description="Configure preferred statutory deductions"
            close={setIsOpen}
          />
        </div>
        <div className='absolute right-0 top-0 flex items-center'>
          <span className='text-[#00535C] font-medium text-[16px]'>{step}</span>
          <span className='text-[#718096] font-medium text-[16px]'>/2</span>
        </div>
      </div>
      
      <div className='flex justify-between pb-6 border-b border-gray-100'>
        <div style={{ width: "81%"}}>
          <h5 style={{ color: "#1A202C"}} className='text-lg font-bold'>Pension</h5>
          <p className='text-base text-ep-gray-600'>Employer (10% of BHT) + Employee Contribution(8% of BHT)</p>
        </div>
        <div className='flex items-start'>
          <CustomSwitch
            onChange={() => {
              setForm(prevState => {
                const newDeductions = {
                  ...prevState.deductions,
                  pension_deduction: {
                    ...prevState.deductions.pension_deduction,
                    is_enabled: !prevState.deductions.pension_deduction.is_enabled,
                    pension_scheme: "EMPLOYER_10_PERCENT_EMPLOYEE_8_PERCENT"
                  }
                }
                
                return {
                  ...prevState,
                  deductions: { ...newDeductions }
                }
              })
            }}
            active={form.deductions.pension_deduction.is_enabled}
            hideSwitchLabel={true}
          />
        </div>
      </div>
      <div className='flex justify-between pt-6 pb-6 border-b border-gray-100'>
        <div style={{ width: "81%"}}>
          <h5 style={{ color: "#1A202C"}} className='text-lg font-bold'>NHF</h5>
          <p className='text-base text-ep-gray-600'>National Housing Fund</p>
        </div>
        <div className='flex items-start'>
          <CustomSwitch
            onChange={() => handleDeductionsChange("nhf")}
            active={form.deductions.nhf}
            hideSwitchLabel={true}
          />
        </div>
      </div>
      <div className='flex justify-between pt-6 pb-6 border-b border-gray-100'>
        <div style={{ width: "81%"}}>
          <h5 style={{ color: "#1A202C"}} className='text-lg font-bold'>NSITF</h5>
          <p className='text-base text-ep-gray-600'>Nigeria Social Insurance Trust Fund</p>
        </div>
        <div className='flex items-start'>
          <CustomSwitch
            onChange={() => handleDeductionsChange("nsitf")}
            active={form.deductions.nsitf}
            hideSwitchLabel={true}
          />
        </div>
      </div>
      <div className='flex justify-between pt-6 pb-6 border-b border-gray-100'>
        <div style={{ width: "81%"}}>
          <h5 style={{ color: "#1A202C"}} className='text-lg font-bold'>ITF</h5>
          <p className='text-base text-ep-gray-600'>Industrial Training Fund</p>
        </div>
        <div className='flex items-start'>
          <CustomSwitch
            onChange={() => handleDeductionsChange("itf")}
            active={form.deductions.itf}
            hideSwitchLabel={true}
          />
        </div>
      </div>
      <Maybe 
        condition={form.deductions.custom_deductions.length > 0}
      >
        <CustomDeductions 
          form={form} 
          setForm={setForm}
        />
      </Maybe>
      <div className='cursor-pointer flex items-center w-fit pt-4' onClick={handleAddNewCustomDeduction}>
        <AddIcon width={20} height={20} className='add-icon' />
        <p className='font-medium ml-2' style={{ color: "#006770" }}>Add Custom Deduction</p>
      </div>
      <div className="mt-14 flex justify-end space-x-4">
        <button 
          type="button" 
          onClick={handleTogglePayStructureModal} className="btn btn-lg btn-transparent-primary"
        >
          Cancel
        </button>
        <ButtonLoader 
          className="btn btn-lg btn-ep-primary" 
          disabled={isSubmitBtnDisabled} 
          type="submit"
          loading={loading || editLoading}
        >
          {formAction === "create" ? "Create" : "Edit"} Pay Structure
        </ButtonLoader>
      </div>
    </div>
  )
}
